import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IPropType } from '../../../all-types'
import { getPropsList } from '../../../services'

const initialState: {
    props: IPropType[],
} = {
    props: [],
}

export const PropsSlice = createSlice({
    name: 'props',
    initialState,
    reducers: {
        setProps: (state, action: PayloadAction<IPropType[]>) => {
            state.props = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getPropsList.fulfilled, (state, action) => {
            state.props = action.payload
        })
    },
})

export const { setProps } = PropsSlice.actions
